<template>
  <div :class="{ isNoticeHead: !$store.state.isIndexTopNotice, mainBody: $store.state.isIndexTopMainBody }">
    <div class="py-4 lg:py-6 xl:pt-8 xl:pb-12 max-w-lg lg:max-w-3xl mx-auto">
      <div class="mx-auto mb-4 sm:border border-gray-700 rounded overflow-hidden">
        <div class="flex flex-wrap">
          <div id="first" class="first w-full lg:w-1/2 flex h-auto justify-center firstShoppingBg">
            <div class="first text-center textColorDark pt-4 md:pt-6 lg:pt-16 pb-6 md:pb-8r">
              <h5 class="mb-8 text-dark-Gray text-NotoSansRegular text-2xl tracking-wider font-semibold">第一次購物</h5>
              <p class="mb-1 text-dark-Gray text-NotoSansRegular text-base tracking-wider font-semibold">不需加入會員即可購物！</p>
              <p class="mb-1 text-dark-Gray text-NotoSansRegular text-base tracking-wider font-semibold">訂單完成後系統將會幫您加入會員。</p>
              <p class="mb-10 text-dark-Gray text-NotoSansRegular text-base tracking-wide">※會員請直接用Email登入</p>
              <a @click="firstShopping" class="block firstShopBtn firstShopBtnWeb tracking-wider mt-5 mb-8 py-3 w-full rounded text-NotoSansBold cursor-pointer text-lg">
                前往購物車
              </a>
            </div>
          </div>
          <!-- <div class="first text-center textColorDark text-sm px-8 sm:px-0 text-NotoSansRegular lg:hidden w-full">
            <p class="leading-loose mb-3 text-xl font-bold">第一次購物</p>
            <p class="lleading-loose mb-0 font-bold">不需加入會員即可購物！</p>
            <p class="lleading-loose mb-0 font-bold">訂單完成後系統將自動幫您加入會員</p>
            <p class="lleading-loose mb-6">※會員請直接用Email登入</p>
            <a @click="firstShopping" class="inline-block text-base firstShopBtn tracking-wider mt-2 mb-4 bg-transparent hover:bg-gray-700 textColorDarkBlack hover:text-white py-2 px-6 border border-gray-700 hover:border-transparent rounded text-NotoSansRegular cursor-pointer">
              前往購物車
            </a>
          </div> -->
          <!-- <p class="text-center text-sm mb-4 text-NotoSansRegular textColor-searchBar">登入等同於您同意
            <router-link :to="{ name: 'policy' }" class="underline">服務條款</router-link>
            與
            <router-link :to="{ name: 'privacy' }" class="underline">隱私權政策</router-link>
          </p> -->
          <div class="signin w-full lg:w-1/2 flex justify-center sm:justify-end">
            <div class="w-full pt-4 md:pt-8 lg:pt-12 pb-6 md:pb-8">
              <div class="dialog__header mb-4">
                <p class="text-NotoSansBold text-center text-base align-top tracking-wide textColorDark hidden sm:block">
                  若您為原官網會員
                </p>
                <p class="text-NotoSansBold text-center text-base align-top mb-2 tracking-wide textColorDark hidden sm:block">
                  請直接以Email登入即可
                </p>
                <p class="text-NotoSansBold text-center text-xl align-top mb-2 tracking-wide textColorDark sm:hidden">
                  會員登入
                </p>
              </div>
              <div class="dialog__body">
                <form class="bg-white px-4 md:px-8 pt-4 pb-4 lg:pb-6" id="form-login" action="" method="POST">
                  <div class="mb-6 relative">
                    <input type="email" class="borderColorDarkGray text-sm input-text appearance-none border rounded w-full py-3 px-3 textColorDarkBlack leading-tight focus:outline-none focus:border-gray-900"
                      id="username" placeholder="Email Address 會員帳號" v-model.trim="account" autocomplete="off"  name="account" v-on:keyup.13="codeCheck" />
                    <label class="label-helper block textColorDarkBlack text-xs mb-2" for="username">會員帳號</label>
                  </div>
                  <div class="mb-2 relative">
                    <input type="password" class="borderColorDarkGray text-sm input-text appearance-none border rounded w-full py-3 px-3 textColorDarkBlack leading-tight focus:outline-none focus:border-gray-900"
                      id="password" placeholder="Password 會員密碼" v-model.trim="password" autocomplete="off"  name="password" v-on:keyup.13="codeCheck" />
                    <label class="label-helper block textColorDarkBlack text-xs mb-2" for="password">會員密碼</label>
                  </div>

                  <div class="mb-4 px-4 sm:px-0 flex justify-start">
                    <router-link :to="{ name: 'forgotPwd' }" class="inline-block align-baseline text-sm textColorDarkBlack text-NotoSansRegular cursor-pointer hover:underline">
                      忘記密碼？
                    </router-link>
                  </div>

                  <button class="text-sm button-red text-white py-3 px-4 rounded outline-none focus:outline-none w-full text-NotoSansRegular mb-3"
                    type="button" @click.prevent="codeCheck" :class="{ disabled: isLogining }" :disabled="isLogining">
                    <span v-if="!isLogining">登入</span>
                    <font-awesome-icon icon="circle-notch" spin v-if="isLogining" />
                  </button>

                  <!-- 註冊 -->
                  <div>
                    <p class="mb-2 px-4 sm:px-0 inline-block align-baseline text-sm textColorDarkBlack text-NotoSansRegular">
                      還不是會員？
                    </p>
                    <button class="text-sm button-register py-3 px-4 rounded outline-none focus:outline-none w-full text-NotoSansRegular mb-3"
                      type="button" @click.prevent="toRegister">
                      <span>註冊帳號</span>
                    </button>
                  </div>

                  <!-- 使用Facebook登入 -->
                  <facebookLogin class="mb-3 w-full" v-if="$store.state.nodeEnv !== 'production'" />
                  <googleLogin />
                </form>
                <!-- <div class="first text-center textColorDark text-sm px-8 sm:px-0 text-NotoSansRegular lg:hidden">
                  <p class="leading-loose mb-3 text-xl font-bold">第一次購物</p>
                  <p class="lleading-loose mb-0 font-bold">不需加入會員即可購物！</p>
                  <p class="lleading-loose mb-0 font-bold">訂單完成後系統將自動幫您加入會員</p>
                  <p class="lleading-loose mb-6">※會員請直接用Email登入</p>
                  <a @click="firstShopping" class="inline-block text-base firstShopBtn tracking-wider mt-2 mb-4 bg-transparent hover:bg-gray-700 textColorDarkBlack hover:text-white py-2 px-6 border border-gray-700 hover:border-transparent rounded text-NotoSansRegular cursor-pointer">
                    前往購物車
                  </a>
                </div> -->
                <p class="text-center text-sm mb-4 text-NotoSansRegular textColor-searchBar">登入等同於您同意
                  <router-link :to="{ name: 'policy' }" class="underline">服務條款</router-link>
                  與
                  <router-link :to="{ name: 'privacy' }" class="underline">隱私權政策</router-link>
                </p>
              </div>
            </div>
          </div>
          <div class="hidden lg:block">
            <p class="text-center text-sm my-6 hidden text-NotoSansRegular">登入等同於您同意
              <router-link :to="{ name: 'policy' }" class="underline">服務條款</router-link>
              與
              <router-link :to="{ name: 'privacy' }" class="underline">隱私權政策</router-link>
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable no-unused-expressions */
import { mapGetters, mapActions } from 'vuex'
import axios from 'axios'
import advertising from '@/components/modules/advertising'
import Regex from '@/components/modules/regex'
import ga4 from '@/components/modules/ga4'
import sweetAlert from '@/components/modules/sweetAlert'
import addCart from '@/components/modules/addCart'
import googleLogin from '@/components/googleLogin.vue'
import facebookLogin from '@/components/facebookLogin.vue'
export default {
  name: 'Login',
  metaInfo () {
    return {
      title: '會員登入',
      titleTemplate: null,
      meta: [
        { hid: 'robots', name: 'robots', content: 'noindex' }
      ]
    }
  },
  data () {
    return {
      account: '',
      password: '',

      isLogining: false,
      isLoginingFB: false
    }
  },
  components: {
    googleLogin,
    facebookLogin
  },
  mixins: [
    advertising,
    Regex,
    ga4,
    sweetAlert,
    addCart
  ],
  watch: {
  },
  computed: {
    ...mapGetters([
      'authorized',
      'userRole',
      'cartNum',
      'routeRecord',
      'user'
    ])
  },
  mounted () {
    this.$route.query.token ? this.useTokenToLogin() : this.isAuthorized()
  },
  updated () {
  },
  methods: {
    ...mapActions({
      dologin: 'login',
      dologinFB: 'loginFB',
      useTokenLogin: 'useTokenLogin'
    }),

    isAuthorized () {
      if (this.authorized) {
        this.$router.push({ name: 'index' })
      }
    },

    codeCheck () {
      const { account, password } = this
      if (account && password && this.rexEmail(account)) {
        this.loginAdmin()
      } else {
        this.alertPop('error', '資料未填寫或email格式錯誤')
      }
    },

    async useTokenToLogin () {
      await this.useTokenLogin(this.$route.query.token)
      if (this.authorized && this.user && this.user.name && this.user.email) {
        this.$router.push({ name: 'manage' })
      }
    },

    async loginAdmin () {
      this.isLogining = true

      await this.dologin({ account: this.account, password: this.password })
      if (this.authorized) {
        this.$router.push({ name: this.routeRecord })
        this.$store.dispatch('routeRecord', { routeName: 'index' })
        this.isLogining = false
        this.isLoginingFB = false
        this.loginCode(this.account)

        // ga4
        this.login_track()

        this.$store.dispatch('updateLocalCart')
      } else {
        this.isLogining = false
        this.isLoginingFB = false
        this.alertPop('error', '帳號密碼錯誤')
      }
    },

    async loginByFb () {
      // eslint-disable-next-line
      await FB.getLoginStatus(async response => {
        if (response.status === 'connected') {
          await this.dologinFB({ accessToken: response })
        } else {
          // eslint-disable-next-line
          await FB.login((response) => {
            if (response.authResponse) {
              this.dologinFB({ accessToken: response })
              // ga4
              this.login_track()
            }
          }, {
            scope: 'email, public_profile',
            return_scopes: true
          })
        }
      })
    },

    firstShopping () {
      this.$router.push({ name: 'checkout' })
    },

    forgetPwdSubmit () {
      this.isReseting = true
      if (this.forgetPwdEmail !== null) {
        axios.post(`/password/email?email=${this.forgetPwdEmail}`)
          .then((response) => {
            this.isReseting = false
            if (response.data.email === "We can't find a user with that e-mail address.") {
              this.alertPop('warning', '此帳號不存在!!')
              // this.$store.dispatch('updateAlert', { isAlert: true, isHead: false, alertMsg: '此帳號不存在!!', type: 'alert' })
            } else {
              this.alertPop('warning', '系統將自動發送密碼變更信至您的信箱，請利用該信來變更您的密碼。')
              // this.$store.dispatch('updateAlert', { isAlert: true, isHead: true, alertMsg: '系統將自動發送密碼變更信至您的信箱，請利用該信來變更您的密碼。', type: 'alert' })
            }
          })
          .catch(() => {
            this.isReseting = false
          })
      }
    },

    toRegister () {
      this.$router.push({ name: 'register' })
    }
  }
}
</script>

<style lang="scss" scoped>
  .disabled {
    background-color: #872122 !important;
    cursor: not-allowed;
  }
  .disabledFB {
    background-color: #29487d;
    cursor: not-allowed;
  }
  .firstShopBtn {
    transition: .3s;
  }
  .firstShopBtnWeb {
    background-color: rgb(255, 255, 255);
    color: #4B4B4B;
    &:hover {
      background-color: #4B4B4B;
      color: #FFFFFF;
    }
  }

  .liveAbcLogo img {
  -webkit-box-reflect: below 0 -webkit-linear-gradient(top,rgba(250,250,250,0),rgba(250,250,250,.0) 30%,rgba(250,250,250,.3));
  }

  .firstShoppingBg {
    background: linear-gradient(180deg, #FFFFFF 11.56%, rgba(255, 255, 255, 0) 62.81%), url('~@/assets/images/banner/loginB.png');
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;
  }

  .forgotPwdBanner {
    max-height: 200px;
  }
  .button-register {
    background-color: #4B4B4B;
    color: #ffffff;
    transition: .3s;
    &:hover {
      background-color: #3d3d3d;
    }
  }
.dialog__header {
    font-size: 20px;
}
.dialog__body {
  .fb-btn {
    transition: 0.3s;
    background-color: #3b5998;
    &:hover {
      background-color: #29487d;
    }
  }
  .lineBtn {
    transition: 0.3s;
    background-color: #00C300;
    &:hover {
      background-color: #00E000;
    }
    &:focus {
      background-color: #00E000;
    }
  }
  .disableLine {
    background-color: #C6C6C6;
    cursor: not-allowed;
  }
  #my-signin2{
    .abcRioButtonContentWrapper {
      display: flex;
      justify-content: center;
    }
    width: 100% !important;
    .abcRioButton, .abcRioButtonBlue {
      background-color: white;
      width: 100% !important;
      height: 40px !important;
      border-radius: 0.25rem !important;
      height: auto;
      &:hover {
        box-shadow: 0 2px 4px 0 rgba(0,0,0,.25);
      }
      .abcRioButtonContents {
      font-weight: 700 !important;
      font-size: 1rem !important;
      color: black;
      }
    }
  }
  .social-login-option:before, .social-login-option:after {
      background-color: #dde1e4;
      content: "";
      display: inline-block;
      height: 1px;
      position: relative;
      vertical-align: middle;
      width: 45%;
  }
  .social-login-option:before {
    right: .5rem;
  }
  .social-login-option:after {
    left: .5em;
  }
}

.input-text {
  background-color: white;
  border: 1px solid #cccccc;
  padding: 8px 4px;
  position: relative;
  width: 100%;
  z-index: 3;
}

.label-helper {
  position: absolute;
  opacity: 0;
  transition: .2s bottom, .2s opacity;
  bottom: 0;
  left: 0;
  z-index: 1;
}

.input-text:focus + .label-helper, .input-text:invalid + .label-helper {
  bottom: 95%;
  line-height: 1;
  opacity: 1;
  }

.input-text:not(:placeholder-shown) ~ label,
.input-text:-webkit-autofill ~ label
{
  bottom: 95%;
  line-height: 1;
  opacity: 1;
}

</style>
